export * from './app-aside.component';



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/components/app-aside/index.ts